"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InboxMessageKind = void 0;
// CHRIS: TODO: docs
var InboxMessageKind;
(function (InboxMessageKind) {
    InboxMessageKind[InboxMessageKind["L1MessageType_submitRetryableTx"] = 9] = "L1MessageType_submitRetryableTx";
    InboxMessageKind[InboxMessageKind["L1MessageType_ethDeposit"] = 12] = "L1MessageType_ethDeposit";
})(InboxMessageKind = exports.InboxMessageKind || (exports.InboxMessageKind = {}));
